'use client';

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { BriefingContent } from './briefing-content';

// ---------------------------------------------------------------------------
// BriefingCard — a single chapter card for the tile view
// ---------------------------------------------------------------------------

export interface BriefingSection {
  index: number;
  /** Number shown to the reader (heading's own number, e.g. "0") */
  label?: string;
  title: string;
  markdown: string;
}

interface BriefingCardProps {
  section: BriefingSection;
}

export function BriefingCard({ section }: BriefingCardProps) {
  return (
    <Card
      id={`section-${section.index}`}
      className="card-shadow border-border briefing-card"
    >
      <CardHeader className="pb-0">
        <CardTitle className="text-base flex items-center gap-2">
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent text-accent-foreground text-xs font-bold flex-shrink-0">
            {section.label ?? section.index}
          </span>
          {section.title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <BriefingContent markdown={section.markdown} />
      </CardContent>
    </Card>
  );
}
